// @ts-ignore
import crypto from "crypto";

function createSha256HashWith1000Iterations(value: string): string {
    // @ts-ignore
    const buffer = Buffer.from(value, "utf8");
    let hash = crypto.createHash("sha256");
    hash.update(buffer);
    let digest = hash.digest();
    for (let index = 1; index < 1000; index++) {
        hash = crypto.createHash("sha256");
        hash.update(digest);
        digest = hash.digest();
    }

    return digest.toString("hex");
}

export {
    createSha256HashWith1000Iterations
};
